﻿export const videoHeroBannerState = function () {
	return {
		data: null,
		container: null,
		/**
		 * INIT METHOD.
		 * Sets the initialPageLength, defaults to 10.
		 * Sets the column filter options.
		 */
		setupComponent: function ({ data }) {
			this.container = this.$refs.container;
			this.data = data;
		},

		get dataItems() {
			return this.data;
		},

		getMarkup: function () {
			if (this.data === null) {
				return "";
			} else {
				return this.data.Contents;
			}
		},
		autoPlayVideo: function () {
			// Grab the prefers reduced media query.
			const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

			// Check if the media query matches or is not available.
			if (!mediaQuery || mediaQuery.matches) {
				return false;
			}

			return true;
		},
		getStyle: function (visible) {
			if (this.autoPlayVideo() && visible == true) {
				return "height:70vh; width: 100%; aspect-ratio: 16/9;";
			} else {
				return "background-image: url(/images/hero.jpg); background-size: cover; background-repeat: no-repeat; height: 70vh; width: 100%; aspect-ratio: 16/9;";
			}
		}
	};
};
